import { render, staticRenderFns } from "./MoveFileToFolder.vue?vue&type=template&id=1f9ec027&scoped=true"
import script from "./MoveFileToFolder.vue?vue&type=script&lang=js"
export * from "./MoveFileToFolder.vue?vue&type=script&lang=js"
import style0 from "./MoveFileToFolder.vue?vue&type=style&index=0&id=1f9ec027&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9ec027",
  null
  
)

export default component.exports